<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-09-07 09:36:58
 * @LastEditTime: 2020-09-07 14:16:38
 * @Description: 
-->
<template>
  <div class="section">
    <h2 class="section-title">运输单</h2>
    <div
      v-for="d in displayData"
      class="section-block"
    >
      <h3 class="block-title">{{ d.title }}</h3>
      <span class="block-displaytext">{{ d.displayText || "-" }}</span>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "SecDelivery",
  data() {
    return {
      delivery: null,
      salesOrder: null,
      displayData: {
        driver: {
          key: "driver",
          title: "司机",
          type: "String",
          displayText: "-",
        },
        vehicle: {
          key: "vehicle",
          title: "车辆",
          type: "String",
          displayText: "-",
        },
        createdBy: {
          key: "createdBy",
          title: "创建人",
          lock: true,
          type: "String",
          displayText: "-",
        },
        createdAt: {
          key: "createdAt",
          title: "创建时间",
          lock: true,
          type: "String",
          displayText: "-",
        },
        arrivedAt: {
          key: "arrivedAt",
          title: "实际抵达时间",
          lock: true,
          type: "String",
          displayText: "-",
        },
      },
    };
  },
  methods: {
    loadData(payload) {
      this.delivery = payload.delivery;
      console.log(payload.delivery);
      this.salesOrder = payload.SPO ? payload.SPO : null;
      this.displayData.createdAt.displayText =
        this.delivery && this.delivery.createdAt
          ? dayjs(this.delivery.createdAt).format("M月D日 HH:mm")
          : null;
      this.displayData.createdBy.displayText = this.delivery
        ? this.delivery.createdBy?.name
        : null;
      this.displayData.arrivedAt.displayText = this.salesOrder.arrivedAt
        ? dayjs(this.delivery.arrivedAt).format("M月D日 HH:mm")
        : null;
      this.displayData.driver.displayText =
        this.delivery && this.delivery.driver
          ? this.delivery.driver.map((x) => x.name).join(", ")
          : null;
      this.displayData.vehicle.displayText =
        this.delivery && this.delivery.vehicle
          ? this.delivery.vehicle.plate
          : null;
    },
  },
  watch: {},
};
</script>

<style scoped lang="stylus">
.section
  display flex
  align-content flex-start
  flex-wrap wrap
  margin-bottom 12px

.section-title
  width 100%
  font-weight 450
  margin-bottom 12px
  color #3e3e3e

.block-title
  float left
  width 130px
  font-weight 400
  color #888

.block-displaytext
  float left
  font-weight 450
  font-size 14px

.section-block
  width 50%
  line-height 26px
  margin-bottom 8px
</style>
